<template>
    <div class="bg">
        <div class="wrap">
            <div class="info-wrap">
                <div class="item-wrap">
                    <span class="title">{{title_1}}</span>

                    <div class="range">
                        <span>身高</span>
                        <div class="range-content">
                            <range-slider
                                    v-model="data.base_height"
                                    class="slider"
                                    min="10"
                                    max="300"
                                    step="1">
                            </range-slider>
                        </div>
                        <span>{{data.base_height}}</span>
                        <label>cm</label>
                    </div>

                    <div class="range">
                        <span>体重</span>
                        <div class="range-content">
                            <range-slider
                                    v-model="data.base_weight"
                                    class="slider"
                                    min="10"
                                    max="300"
                                    step="1">
                            </range-slider>
                        </div>
                        <span>{{data.base_weight}}</span>
                        <label>kg</label>
                    </div>

                    <div class="item">
                        <span>BMI</span>
                        <input type="number" v-model="data.base_bmi" readonly>
                        <label>kg/m<sup>2</sup></label>
                    </div>

                    <div v-if="bmi_suggestion!=''" class="conclusion">
                        <img src="../../assets/img/icon_hint.png">
                        <span>您的身体质量指数（BMI）结果为：{{bmi_suggestion}}</span>
                    </div>

                    <div class="range">
                        <span>腰围</span>
                        <div class="range-content">
                            <range-slider
                                    v-model="data.base_waist"
                                    class="slider"
                                    min="50"
                                    max="350"
                                    step="1">
                            </range-slider>
                        </div>
                        <span>{{data.base_waist}}</span>
                        <label>cm</label>
                    </div>

                    <div class="range">
                        <span>臀围</span>
                        <div class="range-content">
                            <range-slider
                                    v-model="data.base_butt"
                                    class="slider"
                                    min="50"
                                    max="350"
                                    step="1">
                            </range-slider>
                        </div>
                        <span>{{data.base_butt}}</span>
                        <label>cm</label>
                    </div>


                    <div class="item">
                        <span>腰臀比</span>
                        <div class="item-content">
                            <input type="number" v-model="data.base_waist_butt_ratio">
                        </div>

                    </div>

                    <div v-if="waist_butt_ratio_suggestion!=''" class="conclusion">
                        <img src="../../assets/img/icon_hint.png">
                        <span>您的腰臀比指数（WHR）结果为：{{waist_butt_ratio_suggestion}}</span>
                    </div>


                    <div class="range">
                        <span>收缩压</span>
                        <div class="range-content">
                            <range-slider
                                    v-model="data.base_blood_high"
                                    class="slider"
                                    min="10"
                                    max="300"
                                    step="1">
                            </range-slider>
                        </div>
                        <span>{{data.base_blood_high}}</span>
                        <label>mmhg</label>
                    </div>

                    <div class="range">
                        <span>舒张压</span>
                        <div class="range-content">
                            <range-slider
                                    v-model="data.base_blood_low"
                                    class="slider"
                                    min="10"
                                    max="300"
                                    step="1">
                            </range-slider>
                        </div>
                        <span>{{data.base_blood_low}}</span>
                        <label>mmhg</label>
                    </div>

                    <div class="range">
                        <span>心率</span>
                        <div class="range-content">
                            <range-slider
                                    v-model="data.base_heart"
                                    class="slider"
                                    min="10"
                                    max="300"
                                    step="1">
                            </range-slider>
                        </div>
                        <span>{{data.base_heart}}</span>
                        <label>次/分</label>
                    </div>


                </div>

                <div class="item-wrap">
                    <span class="title">{{title_2}}</span>

                    <div class="range">
                        <div class="note">
                            <span>FBG</span>
                            <span>空腹血糖</span>
                        </div>
                        <div class="range-content">
                            <range-slider
                                    v-model="data.base_fbg"
                                    class="slider"
                                    min="1"
                                    max="33.3"
                                    step="0.1">
                            </range-slider>
                        </div>
                        <span>{{data.base_fbg.toFixed(2)}}</span>
                    </div>

                    <div class="range">
                        <div class="note">
                            <span>INS</span>
                            <span>空腹胰岛素</span>
                        </div>
                        <div class="range-content">
                            <range-slider
                                    v-model="data.base_homa"
                                    class="slider"
                                    min="1"
                                    max="33.0"
                                    step="0.1">
                            </range-slider>
                        </div>
                        <span>{{data.base_homa.toFixed(2)}}</span>
                    </div>

                    <div class="item">
                        <div class="note" style="width: 40%">
                            <span>HOMA-IR</span>
                            <span>胰岛素抵抗指数</span>
                        </div>
                        <input type="number" v-model="data.base_homa_ir" readonly>
                    </div>

                    <div class="range">
                        <div class="note">
                            <span>PPG</span>
                            <span>餐后血糖</span>
                        </div>
                        <div class="range-content">
                            <range-slider
                                    v-model="data.base_ppg"
                                    class="slider"
                                    min="1.0"
                                    max="33.3"
                                    step="0.1">
                            </range-slider>
                        </div>
                        <span>{{data.base_ppg.toFixed(2)}}</span>
                    </div>

                    <div class="range">
                        <div class="note">
                            <span>HBA1C</span>
                            <span>糖化血红蛋白</span>
                        </div>
                        <div class="range-content">
                            <range-slider
                                    v-model="data.base_hba1c"
                                    class="slider"
                                    min="1"
                                    max="10"
                                    step="0.1">
                            </range-slider>
                        </div>
                        <span>{{data.base_hba1c.toFixed(2)}}</span>
                    </div>

                </div>

                <div class="item-wrap">
                    <span class="title">{{title_3}}</span>

                    <div class="range">
                        <div class="note">
                            <span>TG</span>
                            <span>甘油三酯</span>
                        </div>
                        <div class="range-content">
                            <range-slider
                                    v-model="data.base_tg"
                                    class="slider"
                                    min="0"
                                    max="10"
                                    step="0.1">
                            </range-slider>
                        </div>
                        <span>{{data.base_tg.toFixed(2)}}</span>
                    </div>

                    <div class="range">
                        <div class="note">
                            <span>TC</span>
                            <span>总胆固醇</span>
                        </div>
                        <div class="range-content">
                            <range-slider
                                    v-model="data.base_tc"
                                    class="slider"
                                    min="3"
                                    max="13"
                                    step="0.1">
                            </range-slider>
                        </div>
                        <span>{{data.base_tc.toFixed(2)}}</span>
                    </div>

                    <div class="range">
                        <div class="note">
                            <span>HDL_C</span>
                            <span>高密度脂蛋白</span>
                        </div>
                        <div class="range-content">
                            <range-slider
                                    v-model="data.base_hdl_c"
                                    class="slider"
                                    min="0"
                                    max="10"
                                    step="0.1">
                            </range-slider>
                        </div>
                        <span>{{data.base_hdl_c.toFixed(2)}}</span>
                    </div>

                    <div class="range">
                        <div class="note">
                            <span>LDL_C</span>
                            <span>低密度脂蛋白</span>
                        </div>
                        <div class="range-content">
                            <range-slider
                                    v-model="data.base_ldl_c"
                                    class="slider"
                                    min="1"
                                    max="11"
                                    step="0.1">
                            </range-slider>
                        </div>
                        <span>{{data.base_ldl_c.toFixed(2)}}</span>
                    </div>

                </div>
            </div>

            <div class="next">
                <span @click="toNext">{{next}}</span>
            </div>

        </div>
    </div>

</template>

<script>
    import RangeSlider from 'vue-range-slider'
    import 'vue-range-slider/dist/vue-range-slider.css'

    import {addCase, getCase} from "@/assets/js/api";

    export default {
        name: 'HelloWorld',
        components: {
            RangeSlider,
        },
        data() {
            return {
                title_1: "3、基本检查",
                title_2: "4、血糖值",
                title_3: "5、血生化指标",

                data: {
                    base_height: "",
                    base_weight: "",
                    base_blood_high: "",
                    base_blood_low: "",
                    base_heart: "",
                    base_waist: "",
                    base_butt: "",
                    base_waist_butt_ratio: "",
                    base_bmi: "",
                    base_fbg: 0,
                    base_ppg: 0,
                    base_hba1c: 0,
                    base_homa: 0,
                    base_homa_ir: 0,
                    base_tg: 0,
                    base_tc: 0,
                    base_hdl_c: 0,
                    base_ldl_c: 0,
                    caseId: this.$store.state.caseId,
                    docId: this.$store.state.docId,
                },
                gender: "",
                bmi_suggestion: "",
                waist_butt_ratio_suggestion: "",
                rangeValue: "",
                next: "下一步 >",
                editStation:0
            }
        },
        methods: {
            async toNext() {

                if(this.editStation==1){ //审核通过的
                    this.toRes();//进入下一步
                    return
                }

                if (this.data.base_height == "" || this.data.base_weight == "" || this.data.base_blood_high == "" || this.data.base_blood_low == "" || this.data.base_heart == "" || this.data.base_butt == "" || this.data.base_waist == "") {
                    this.$toast("请填写基本检查信息")
                    return
                }

                if (this.data.base_fbg == 0 || this.data.base_ppg == 0 || this.data.base_hba1c == 0 || this.data.base_homa == 0) {
                    this.$toast("请选择血糖值")
                    return
                }

                if (this.data.base_tg == 0 || this.data.base_tc == 0 || this.data.base_hdl_c == 0 || this.data.base_ldl_c == 0) {
                    this.$toast("请选择血生化指标")
                    return
                }

                this.data.base_ppg = parseFloat(this.data.base_ppg.toFixed(2))
                this.data.base_fbg = parseFloat(this.data.base_fbg.toFixed(2))//保留两位小数
                this.data.base_homa = parseFloat(this.data.base_homa.toFixed(2))//保留两位小数
                // this.data.base_homa_ir = parseFloat(this.data.base_homa_ir.toFixed(2))//保留两位小数
                this.data.base_hba1c = parseFloat(this.data.base_hba1c.toFixed(2))//保留两位小数

                this.data.base_tg = parseFloat(this.data.base_tg.toFixed(2))//保留两位小数
                this.data.base_tc = parseFloat(this.data.base_tc.toFixed(2))//保留两位小数
                this.data.base_hdl_c = parseFloat(this.data.base_hdl_c.toFixed(2))//保留两位小数
                this.data.base_ldl_c = parseFloat(this.data.base_ldl_c.toFixed(2))//保留两位小数


                let data = this.data
                let res = await addCase({data})
                if (res.data.success == true) {
                    this.$store.state.caseId = res.data.data
                    this.toRes();//进入下一步
                } else {
                    this.$toast(res.data.message)
                }
            },
            toRes() {
                this.$router.push({path: "caseRes",query:{scheme:this.$route.query.scheme}})
            },
            async getCase(caseId) {
                let res = await getCase({caseId})

                this.data.base_height = res.data.data.base_height==null?"":res.data.data.base_height
                this.data.base_weight = res.data.data.base_weight==null?"":res.data.data.base_weight
                this.data.base_blood_high = res.data.data.base_blood_high==null?"":res.data.data.base_blood_high
                this.data.base_blood_low = res.data.data.base_blood_low==null?"":res.data.data.base_blood_low
                this.data.base_heart = res.data.data.base_heart==null?"":res.data.data.base_heart
                this.data.base_waist = res.data.data.base_waist==null?"":res.data.data.base_waist
                this.data.base_butt = res.data.data.base_butt==null?"":res.data.data.base_butt

                this.data.base_waist_butt_ratio = res.data.data.base_waist_butt_ratio
                this.data.base_bmi = res.data.data.base_bmi
                this.data.base_fbg = res.data.data.base_fbg == null ? 0 : parseFloat(res.data.data.base_fbg)
                this.data.base_ppg = res.data.data.base_ppg == null ? 0 : parseFloat(res.data.data.base_ppg)
                this.data.base_hba1c = res.data.data.base_hba1c == null ? 0 : parseFloat(res.data.data.base_hba1c)
                this.data.base_homa = res.data.data.base_homa == null ? 0 : parseFloat(res.data.data.base_homa)
                this.data.base_homa_ir = res.data.data.base_homa_ir == null ? 0 : parseFloat(res.data.data.base_homa_ir)
                this.data.base_tg = res.data.data.base_tg == null ? 0 : parseFloat(res.data.data.base_tg)
                this.data.base_tc = res.data.data.base_tc == null ? 0 : parseFloat(res.data.data.base_tc)
                this.data.base_hdl_c = res.data.data.base_hdl_c == null ? 0 : parseFloat(res.data.data.base_hdl_c)
                this.data.base_ldl_c = res.data.data.base_ldl_c == null ? 0 : parseFloat(res.data.data.base_ldl_c)

                this.gender = res.data.data.info_gender;
                this.editStation = res.data.data.sys_station
            }
        },
        mounted() {
            this.getCase(this.data.caseId);
        },
        watch: {
            data: {
                handler(val) {
                    if (val.base_height == null || val.base_height == "" || val.base_weight == null || val.base_weight == "") {
                        this.data.base_bmi = "";
                        this.bmi_suggestion = "";
                    } else {
                        this.data.base_bmi = (val.base_weight / Math.pow(val.base_height / 100, 2)).toFixed(2);
                        this.bmi_suggestion = "体重偏高"
                        if (this.data.base_bmi < 18.5) {
                            this.bmi_suggestion = "体重过轻"
                        } else if (this.data.base_bmi < 23.9) {
                            this.bmi_suggestion = "正常范围"
                        } else if (this.data.base_bmi < 26.9) {
                            this.bmi_suggestion = "过重"
                        } else if (this.data.base_bmi < 29.9) {
                            this.bmi_suggestion = "轻度肥胖"
                        } else if (this.data.base_bmi < 34.9) {
                            this.bmi_suggestion = "中度肥胖"
                        } else if (this.data.base_bmi >= 34.9) {
                            this.bmi_suggestion = "重度肥胖"
                        }
                    }

                    if (val.base_waist == null || val.base_waist == "" || val.base_butt == null || val.base_butt == "") {
                        this.data.base_waist_butt_ratio = "";
                        this.waist_butt_ratio_suggestion = "";
                    } else {
                        this.data.base_waist_butt_ratio = (val.base_waist / val.base_butt).toFixed(2);
                        this.waist_butt_ratio_suggestion = "正常"
                        if (this.gender == "男") {
                            if (this.data.base_waist_butt_ratio > 0.9) {
                                this.waist_butt_ratio_suggestion = "肥胖"
                            }
                        } else {
                            if (this.data.base_waist_butt_ratio > 0.85) {
                                this.waist_butt_ratio_suggestion = "肥胖"
                            }
                        }
                    }

                    if (val.base_fbg == null || val.base_fbg == "" || val.base_homa == null || val.base_homa == "") {
                        this.data.base_homa_ir = "";
                    } else {
                        this.data.base_homa_ir = (val.base_fbg * val.base_homa  / 22.5).toFixed(2);
                    }

                },
                deep: true //true 深度监听
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    .bg{
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
    }

    .wrap {
        width: 100%;
        max-width: 400px;
        height: 100vh;
        background: #FFF;
    }

    .info-wrap {
        width: 100%;
        height: 90%;
        padding-bottom: 10px;
        overflow: scroll;
    }

    .next {
        height: 10%;
        color: #0082C5;
        font-size: 20px;
        margin-right: 30px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .item-wrap {
        width: 95%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: start;
        /*font-size: 20px;*/
        text-align: left;
        text-indent: 10px;

        .title {
            width: 100%;
            background: #0082C5;
            color: #FFF;
            font-size: 22px;
            border-radius: 5px;
            margin-top: 20px;
            padding: 5px 0;
        }

        .item {
            width: 100%;
            background: #D0E6F4;
            line-height: 20px;
            /*font-size: 20px;*/
            padding: 4px 0;
            margin-top: 10px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;

            /*span {*/
            /*    color: #999;*/
            /*}*/

            .item-content {
                flex-grow: 1;
            }
        }
    }


    input {
        width: 100%;
        border: 0;
        background: transparent;
        margin: 0;
        padding: 0;
        height: 30px;
        text-indent: 10px;
        font-size: 20px;
        outline: none;
    }

    label {
        /*width:20%;*/
        margin: 0;
        padding: 0;
        text-align: right;
        /*margin-right: 0px;*/
        color: #999;
    }

    .range {
        width: 100%;
        height: 50px;
        display: flex;
        flex-direction: row;
        align-items: center;
        background: #D0E6F4;
        margin: 0 auto;
        margin-top: 10px;

        /*span:first-child {*/
        /*    color: #999;*/
        /*    font-size: 16px;*/
        /*}*/

        /*span:last-child {*/
        /*    font-size: 20px;*/
        /*    color: #0082C5;*/
        /*}*/

        .range-content {
            flex-grow: 1;
        }
    }

    .mt-range {
        width: 60%;

        div:first-child {
            margin-right: 15px;
        }
    }

    .slider {
        width: 90%;
        .range-slider-inner .range-slider-fill {
            background-color: #0082C5;
            /*width: 50px;*/
        }
    }

    .range-slider{
        padding: 0 0;
    }

    .conclusion {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 10px;
        justify-content: flex-end;

        img {
            margin-left: 10px;
            width: 20px;
            height: 20px;
        }

        span {
            font-size: 15px;
            font-weight: bold;
        }
    }

    .note{
        display: flex;
        flex-direction: column;
        align-items: center;
        span{
            font-size: 10px;
        }
    }

    span{
        font-size: 15px;
        /*color: #0082C5;*/
    }

    label{
        font-size: 15px;
        /*color: #0082C5;*/
    }


</style>
